import {
  CREATE_COMMENT,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_ERROR,
  DELETE_COMMENT,
  DELETE_COMMENT_SUCCESS,
  UPDATE_COMMENT,
  MIGRATE_COMMENT,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_ERROR,
  SEND_EMOJI,
  SEND_EMOJI_SUCCESS,
  LOAD_TASK_COMMENTS,
  LOAD_TASK_COMMENTS_SUCCESS,
} from 'constants/ActionTypes';
import { COMMENT_ENTITY } from 'constants/EntitiesConstants';

import { getIntlMessage } from 'helpers/utilHelpers';

// Handles submitting of comment form
export const createComment = (values, payload) => {
  return {
    type: CREATE_COMMENT,
    payload,
    values,
  };
};

// Handles success create comment
export const createCommentSuccess = (values) => {
  return {
    type: CREATE_COMMENT_SUCCESS,
    values,
  };
};

export const createCommentError = (errors) => {
  return {
    type: CREATE_COMMENT_ERROR,
    errors,
  };
};

// Sending a request to the server to delete comment
export const deleteComment = (commentId) => {
  return {
    type: DELETE_COMMENT,
    payload: {
      resource: 'comments',
      entityId: commentId,
      onSuccess: deleteCommentSuccess,
      onErrorMessage: getIntlMessage('comment.delete.error'),
    },
  };
};

// Delete comment if sending succeed
export const deleteCommentSuccess = (commentId) => {
  return {
    type: DELETE_COMMENT_SUCCESS,
    commentId,
  };
};

// Comment update request
export const updateComment = (commentId, values, payload) => {
  return {
    type: UPDATE_COMMENT,
    payload,
    commentId,
    values,
  };
};

// Comment update success
export const updateCommentSuccess = (comment) => {
  return {
    type: UPDATE_COMMENT_SUCCESS,
    comment,
  };
};

export const updateCommentError = (errors) => {
  return {
    type: UPDATE_COMMENT_ERROR,
    errors,
  };
};

// Sending a request to the server to add reactions
export const sendEmoji = (entityId, values) => {
  return {
    type: SEND_EMOJI,
    payload: {
      resource: 'react',
      commentId: entityId,
      values,
      onSuccess: sendEmojiSuccess,
      onErrorMessage: getIntlMessage('comment.emoji.error'),
    },
  };
};

export const sendEmojiSuccess = (values) => {
  return {
    type: SEND_EMOJI_SUCCESS,
    values,
  };
};

// Send request for migrate comment in other task
export const migrateComment = (commentId, taskId, payload) => {
  return {
    type: MIGRATE_COMMENT,
    payload: {
      resource: `comments/${commentId}/migrate`,
      onSuccess: updateCommentSuccess,
      extraFields: ['privacyUsers'],
      ...payload,
    },
    values: { taskId },
  };
};

export const loadTaskComments = ({ page, filters, scrollCommentId, setIsLoading, ...payload }) => ({
  type: LOAD_TASK_COMMENTS,
  payload: {
    page,
    setIsLoading,
    resource: 'comments',
    extraFields: ['privacyUsers'],
    onSuccess: (response) => loadTaskCommentsSuccess(response, filters.entityId),
    prepareQueryParams: (params) => (scrollCommentId ? { ...params, commentId: scrollCommentId } : params),
    filters: {
      entity: {
        value: COMMENT_ENTITY.task,
      },
      entityId: {
        value: filters.entityId,
      },
    },
    ...payload,
  },
});

const loadTaskCommentsSuccess = (payload, taskId) => ({
  type: LOAD_TASK_COMMENTS_SUCCESS,
  payload,
  meta: {
    taskId,
  },
});
